/**
Author - Venkatesh Pullaganti
Git - https://github.com/venkatesh1146
**/

import BankProof from "./BankProof";

export default BankProof;
